import { useForm } from "react-hook-form"
import { Button } from 'primereact/button';
import { RenderForm } from "../jsonSchemaForm/formRenderer";
import { useDispatch } from "react-redux";
import { authTokenKey, basicFormAuthentication } from "../../store/auth/authSlice";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { handleLoginResponse } from "./loginResponseHandler";
import { emailRegex, publicKeyBufferString } from "../../common/commonHelper";
import { Buffer } from 'buffer';
import { AppLocalStorage } from "../../helpers/localStorageHelper";
import { fetchCaptcha } from "../../store/auth/authSlice";
import { useState } from "react";
import { AppToast } from "../../lib/toast";
import CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from 'uuid';
function BFA(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const form =useForm({ mode: "onChange", reValidateMode: "onChange" });
    const { register, unregister, formState: { errors }, getValues } = form

    const usernameValue = form.watch("username") || "";
    const showCaseHint = /[A-Z]/.test(usernameValue);

    const [captchaImage, setCaptchaImage] = useState(" ");
    const [captchaText, setCaptchaText]=useState(" ");
    const [imageLoaded, setImageLoaded] = useState(false);
   
    const refreshCaptcha = async () => {
        try {
            const encodedCaptcha = await Promise.all([
                dispatch(fetchCaptcha())
            ]);
            var captchaBase64 = CryptoJS.enc.Base64.parse(encodedCaptcha[0].payload.data);
            var decodedCaptcha = JSON.parse(CryptoJS.enc.Utf8.stringify(captchaBase64)); 
            setCaptchaImage(decodedCaptcha.data);
            setCaptchaText(decodedCaptcha.text);
            setImageLoaded(true);
            // Optionally handle the response from the backend if needed
        } catch (error) {
            // Handle errors if the captcha refresh fails
            console.error("Error refreshing captcha:", error);
        }
    };
    
    
    const fields = [{
        field: 'username',
        edit: {
            enabled: true,
            type: "textbox",
            formControlClassName: 'col-md-12 loginArea',
            htmlAttributes: {
                placeholder: `Enter username`,
                onCopy: (e) => e.preventDefault()
            },
            name: 'username',
            label: 'User Name',
            editable: true,
            rules: {
                required: {
                    value: true,
                    message: `Username is required.`
                },
                "pattern": {
                    "value": emailRegex,//"^[A-Z0-9._%+-]+@evalueserve.com$",
                    "message": "Invalid email address. E.g. example@evalueserve.com"
                }
                // "validate": (value) =>
                //     value === value.toLowerCase() ||
                //     "Username is case-sensitive."

            }
        }
    }, {
        field: 'password',
        edit: {
            enabled: true,
            type: "signinPassword",
            formControlClassName: 'col-md-12 loginArea',
            htmlAttributes: {
                placeholder: `Enter password`,
                onCopy: (e) => e.preventDefault()
            },
            name: 'password',
            label: 'Password',
            editable: true,
            rules: {
                required: {
                    value: true,
                    message: `Password is required.`
                }
            }
        },
        
    },
    {
        field: 'captcha',
        edit: {
            enabled: true,
            type: "textbox",
            formControlClassName: 'col-md-6 loginArea',
            htmlAttributes: {
                placeholder: `Enter Captcha`,
                onCopy: (e) => e.preventDefault()
            },
            name: 'Captcha',
            label: 'Captcha',
            editable: true,
            rules: {
                required: {
                    value: true,
                    message: `Captcha is required.`
                }
            }
        },
        
    }]

    useEffect(() => {
        refreshCaptcha();
    }, []);

    useEffect(() => {
        fields.forEach((x) => {
            register(x.field, x.edit?.rules);
            document.getElementById(x.field)?.addEventListener('paste', (e) => e.preventDefault()); // Added this line chirag jain
        });
        return () => {
            fields.forEach((x) => {
                document.getElementById(x.field)?.removeEventListener('paste', (e) => e.preventDefault()); // Added this line chirag jain
                unregister(x.field);
            });
        };
    }, [register, unregister]);

    // useEffect(() => {
    //     dispatch(authTokenKey()).then((res) => { //encrypting the credentials payload during login
    //         if(res.payload.status==200){
    //                 AppLocalStorage.setStorageItem("authKey", res.payload.data.authKey)                                
    //         }
    //     })
    // }, []);

    const handleClick = () => {
        form.handleSubmit((data) => {
            const payload = {
                username: data.username,
                password: data.password,
                captcha: data.captcha,
                token: uuidv4()
            }
            Promise.all([
                dispatch(authTokenKey())
            ]).then(([res]) => {
                if (res.payload.data?.enableAuthKey) {
                    AppLocalStorage.setStorageItem("authKey", res.payload.data.authEncKey)
                    AppLocalStorage.setStorageItem("enableAuthKey", res.payload.data.enableAuthKey)
                    AppLocalStorage.setStorageItem("tokenValidityInMin", res.payload.data.tokenValidityInMin)
                }
                if (data.captcha === captchaText) {
                    dispatch(basicFormAuthentication(payload)).then((response) => {
                        handleLoginResponse(response.payload, navigate, dispatch, refreshCaptcha,form);
                    });
                } else {
                    AppToast.Toast.error({ title: "Invalid Captcha!"})
                    refreshCaptcha();
                    form.setValue('captcha', '');
                }
            }).catch((error) => {
                //console.log(error)
            })

            // dispatch(basicFormAuthentication(payload)).then((res) => { //encrypting the credentials payload during login
            //     handleLoginResponse(res.payload, navigate, dispatch)
            // })
        })()
    }

    return <div>
        <RenderForm form={form} fields={fields} imageLoaded={imageLoaded} captchaImage={captchaImage} refreshCaptcha={refreshCaptcha}/>
        <div className="PrimaryBtn">
            <button type="button" className="btn btn-primary rc_login_btn" onClick={handleClick}>LOGIN</button>
        </div>
    </div>
}

export const FormAuthentication = BFA
